import { Dialog } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import walletService from "../../services/WalletServices";
import closeIcon from "../../assets/icons/ic_close.svg";
import "./zylaPay.scss";

import { CircularProgress } from "@mui/material";
import { IonModal } from "@ionic/react";

function ZylaPay({ orderId, handleClose, openZylaPay }) {
  const [timer, setTimer] = useState({ timing: 300, minutes: "", seconds: "" });
  const [shouldCancel, setShouldCancel] = useState(false);
  const timerInterval = useRef(null);
  const statusCallTimeout = useRef(null);

  useEffect(() => {
    // console.log("order id is ", orderId);
    if (window.Capacitor.platform === "web") {
      zylaPayWebHandler();
    } else {
      zylaPayMobileHandler();
    }
    // NOTE: this cleanup used to RETURN another function instead of doing the
    // work, so the message listener was never removed. Every payment attempt
    // left another listener attached to window.
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("message", handleIframMessage);
      }
      if (timerInterval.current !== null) {
        clearInterval(timerInterval.current);
      }
      if (statusCallTimeout.current !== null) {
        clearTimeout(statusCallTimeout.current);
      }
    };
  }, []);

  useEffect(() => {
    document.addEventListener("ionBackButton", mediHandleBack);

    return () => {
      document.removeEventListener("ionBackButton", mediHandleBack);
    };
  }, []);
  const mediHandleBack = useCallback((ev) => {
    ev.detail.register(10000, () => {
      handleClosePayLoader();
    });
  }, []);

  useEffect(() => {
    if (timer.timing === 0) {
      handleGoBackFunc(false);
    }
  }, [timer]);

  const zylaPayMobileHandler = () => {
    timerInterval.current = setInterval(() => {
      setTimer((prevState) => {
        let newTimings = prevState.timing - 1;
        let sec = newTimings % 60;
        // console.log("new Timings is ", prevState, newTimings);
        return {
          timing: newTimings,
          minutes: parseInt(newTimings / 60),
          seconds: sec < 10 ? `0${sec}` : sec,
        };
      });
    }, 1000);
    checkStatusAndRedirect();
  };

  const zylaPayWebHandler = useCallback(() => {
    window.addEventListener("message", handleIframMessage);
    // Also poll the order, exactly as the native branch does.
    //
    // On web this sheet could ONLY be closed by a postMessage from the payment
    // page — and that page does not send one when the user cancels (verified:
    // nothing arrives on the window at all). So cancelling left the sheet over
    // the whole app with no way out.
    //
    // checkStatusAndRedirect already existed for the native flow: it asks the
    // backend for the order every 5s and closes on status 2 (paid) or 3
    // (cancelled/failed). Web simply never called it. Reusing it avoids adding
    // a second close control next to the payment page's own X.
    checkStatusAndRedirect();
  }, []);

  // `e.origin` is always scheme://host[:port] with no path and no trailing
  // slash. Comparing it to the raw env string only works while that string is
  // in exactly that shape — a trailing slash or a path in the config silently
  // makes every message from the payment page fail this check, and then a
  // cancel is ignored and the sheet stays up with no way out. Normalise both
  // sides so the comparison is on origins.
  const payOrigin = (() => {
    try {
      return new URL(process.env.REACT_APP_ZYLA_PAY_URL).origin;
    } catch {
      return process.env.REACT_APP_ZYLA_PAY_URL;
    }
  })();

  const handleIframMessage = (e) => {
    // Accept on the message's own shape (`data.origin === "ZPAY"`), not only on
    // an exact origin string match.
    //
    // The payment page has its own X, and pressing it left the sheet on screen
    // with no way out — the cancel message was arriving and being discarded, or
    // never matched. `e.origin` is the frame's CURRENT origin, so once the
    // payment page redirects to a gateway and posts from there, an equality
    // check against our configured URL can never pass.
    //
    // The payload still has to be ours, and the only thing it can do is close
    // this sheet, so widening the sender check costs nothing that matters.
    const isOurs = e.data && e.data.origin === "ZPAY";
    if (isOurs) {
      if (e.origin !== payOrigin) {
        console.warn("ZylaPay: message from", e.origin, "expected", payOrigin);
      }
      if (e.data.status === "cancelled") {
        handleClose(false, true);
      } else if (e.data.status === "ok") {
        setTimeout(() => {
          handleClose(true);
        }, 2000);
      }
    }
  };

  const checkStatusAndRedirect = () => {
    walletService
      .getOrderStatus(orderId)
      .then((result) => {
        const res = result.data;
        if (res) {
          if (res.status === 2 || res.status === 3) {
            handleGoBackFunc(
              res.status === 2 ? true : false,
              res.status === 3 ? true : false
            );
          } else {
            handleSetCallTimeout();
          }
        }
      })
      .catch((err) => {
        handleSetCallTimeout();
      });
  };
  const handleSetCallTimeout = () => {
    statusCallTimeout.current = setTimeout(() => {
      checkStatusAndRedirect();
    }, 5000);
  };
  const handleGoBackFunc = (isDone, isCancel = false) => {
    if (timerInterval.current) {
      clearInterval(timerInterval.current);
    }
    if (statusCallTimeout.current) {
      clearTimeout(statusCallTimeout.current);
    }
    handleClose(isDone, isCancel);
  };
  const handleClosePayLoader = () => {
    setShouldCancel((prev) => !prev);
  };

  if (window.Capacitor.platform === "web") {
    return (
      <Dialog
        open={openZylaPay}
        onBackdropClick={() => {}}
        // onDidDismiss={()=>handleClosePayLoader()}
        className="zyla-pay-dialog-fade-in-class zyla-pay-dialog-root-container-100 "
      >
        <div className="zyla-pay-dialog-root-container-div">
          <iframe
            src={`${
              process.env.REACT_APP_ZYLA_PAY_URL
            }?orderId=${orderId}&origin=${
              typeof window !== "undefined" ? window.location.origin : ""
            }`}
            width="100%"
            sandbox="allow-scripts allow-top-navigation allow-pointer-lock allow-same-origin allow-popups allow-forms"
          ></iframe>
        </div>
      </Dialog>
    );
  }
  return (
    <IonModal
      isOpen={openZylaPay}
      disableBackdropClick={false}
      onBackdropClick={() => {}}
      // onDidDismiss={()=>handleClosePayLoader()}
      className="zyla-pay-dialog-fade-in-class zyla-pay-dialog-root-container-100 "
    >
      {window.Capacitor.platform === "web" ? (
        <div className="zyla-pay-dialog-root-container-div">
          <iframe
            src={`${
              process.env.REACT_APP_ZYLA_PAY_URL
            }?orderId=${orderId}&origin=${
              typeof window !== "undefined" ? window.location.origin : ""
            }`}
            width="100%"
            sandbox="allow-scripts allow-top-navigation allow-pointer-lock allow-same-origin allow-popups allow-forms"
          ></iframe>
        </div>
      ) : (
        <React.Fragment>
          <div className="payment-loader-container">
            <img
              src={closeIcon}
              alt="icon"
              className="payment-loader-container-cross"
              onClick={handleClosePayLoader}
            />
            <CircularProgress className="payment-loader-container-progress"></CircularProgress>
            <p className="payment-loader-container-text">
              Complete your payment from your browser &nbsp;
              <strong className="payment-loader-container-text-timer">
                {`0${timer.minutes}:${timer.seconds}`}
                <br />
              </strong>
              If payment is already made, sit back and relax.
            </p>
          </div>
          {shouldCancel && (
            <div className="payment-loader-alert-class">
              <div className="payment-loader-alert-class-box">
                <p>Are you sure you want to cancel the transaction.</p>
                <div className="alert-button-group">
                  <button
                    className="payment-loader-alert-cancel payment-loader-alert-button-common"
                    onClick={() => {
                      setShouldCancel(false);
                      handleGoBackFunc(false, true);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="payment-loader-alert-wait payment-loader-alert-button-common"
                    onClick={() => setShouldCancel(false)}
                  >
                    Wait
                  </button>
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </IonModal>
  );
}

export default ZylaPay;
